module.exports = __webpack_public_path__ + "static/media/img166.a6f94063.jpg";